import type { TabsTabProps } from '@base-ui/react';

import { Tabs as BaseTabs } from '@base-ui/react';

import { clsxs } from '~/styles/utils';

import { Icon, type IconName } from '../Icon/Icon';
import { labelStyle } from './Tabs.css';

type Props = TabsTabProps & {
  icon?: IconName;
};

export const TabsTab = ({ children, icon, ...delegated }: Props) => {
  return (
    <BaseTabs.Tab {...delegated} className={clsxs(labelStyle, delegated.className)}>
      {icon && <Icon name={icon} size={20} />}

      <span>{children}</span>
    </BaseTabs.Tab>
  );
};
